/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const appointmentWhatsappResponses = sqliteTable('appointment_whatsapp_responses', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  appointment_id: text('appointment_id'),
  notification_job_id: text('notification_job_id'),
  inbound_message_id: text('inbound_message_id'),
  response_intent: text('response_intent'),
  response_text: text('response_text'),
  from_phone_e164: text('from_phone_e164'),
  match_strategy: text('match_strategy'),
  responded_at: text('responded_at'),
  created_at: text('created_at'),
});
